export const localStorageKeys = {
  noDataModal: 'noDataModal',
  noCatchment: 'no catchment',
}
